"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTextResource = void 0;
require("../../core");
const parseTextResource = (textResource, replaceTo) => {
    return textResource.replace(/\{\{(.*?)\}\}/g, (match, key) => replaceTo[key]);
};
exports.parseTextResource = parseTextResource;
//# sourceMappingURL=parseTextResource.js.map